import React from 'react';

import { useGiftState } from '@context/gift';
import { pick, pickBy } from '@utils/lodash-utils';

import { analytics, SegmentEventType } from '.';

const useGiftSegment = () => {
  const { selectedGiftType, isOneMonthGiftType } = useGiftState();
  const categoryType = 'Gifting';

  const analyticsFields = React.useMemo(
    () => ({
      'Gift Type': isOneMonthGiftType
        ? 'One-Month Membership Options'
        : selectedGiftType?.label,
      'Gift Sub-Type': isOneMonthGiftType ? selectedGiftType?.label : 'None',
    }),
    [isOneMonthGiftType, selectedGiftType?.label],
  );

  const trackGiftEvents = React.useCallback(
    (
      pageTitle: string,
      requiredFields: Array<string>,
      additionalFields: Record<string, any> = {},
      event: SegmentEventType = 'page',
    ) => {
      const fields = {
        Category: categoryType,
        ...pickBy(
          pick({ ...analyticsFields }, [
            'Gift Type',
            'Gift Sub-Type',
            ...requiredFields,
          ]),
        ),
        ...additionalFields,
      };
      analytics(pageTitle, { ...fields }, event);
    },
    [analyticsFields],
  );

  return { trackGiftEvents };
};

export default useGiftSegment;
